function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import A from '@adsk/alloy-react-a';
import { Box, Flex } from '@adsk/alloy-react-box';
import { OpenIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import { SimpleModal } from '@adsk/alloy-react-modal';
import Theme from '@adsk/alloy-react-theme';
import ACCImage from './assets/ACC_in-product.jpg';
import ACCLifecycle from './assets/Construction-Lifecycle.png';
import { HELP_LINK, LEARNING_CENTER_URL_1, LEARNING_CENTER_URL_2 } from './helpers/const';
import { bodyStyle, footerHelpLinkStyle, imageStyle, imageTextLinkStyle } from './helpers/styles';
import { subscriptionPropType } from '../../helpers/types';
import TrialModalCarousel from '../TrialModalCarousel';
import TrialModalItem from '../TrialModalItem';
const LearningCenterBox = props => /*#__PURE__*/React.createElement(Flex, _extends({
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "space-between",
  paddingLeft: "16px"
}, props));
const TrialModal = _ref => {
  var _T$translate;
  let {
    onClose,
    show,
    userTrials
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../../i18n/".concat(locale, ".json"));
  });
  const getBannerContent = () => [/*#__PURE__*/React.createElement(LearningCenterBox, {
    key: "content-1"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Box, {
    typography: "bodySmallBold"
  }, T.translate('MODAL_IMAGE_TEXT_INTRODUCTION_1')), /*#__PURE__*/React.createElement(Box, {
    typography: "bodySmall"
  }, T.translate('MODAL_IMAGE_TEXT_DESCRIPTION_1')), /*#__PURE__*/React.createElement(A, {
    style: imageTextLinkStyle,
    href: LEARNING_CENTER_URL_1,
    target: "_blank"
  }, T.translate('MODAL_IMAGE_TEXT_LINK'))), /*#__PURE__*/React.createElement("img", {
    style: imageStyle,
    src: ACCLifecycle
  })), /*#__PURE__*/React.createElement(LearningCenterBox, {
    key: "content-0"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    typography: "bodySmallBold"
  }, T.translate('MODAL_IMAGE_TEXT_INTRODUCTION_2')), /*#__PURE__*/React.createElement(Box, {
    typography: "bodySmall"
  }, T.translate('MODAL_IMAGE_TEXT_DESCRIPTION_2')), /*#__PURE__*/React.createElement(A, {
    style: imageTextLinkStyle,
    href: LEARNING_CENTER_URL_2,
    target: "_blank"
  }, T.translate('MODAL_IMAGE_TEXT_LINK'))), /*#__PURE__*/React.createElement("img", {
    style: imageStyle,
    src: ACCImage
  }))];
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: (_T$translate = T.translate('MODAL_TITLE')) === null || _T$translate === void 0 ? void 0 : _T$translate.toString(),
    onClose: () => {
      onClose();
    },
    show: show,
    modalBodyProps: {
      style: bodyStyle
    }
  }, /*#__PURE__*/React.createElement(TrialModalCarousel, null, getBannerContent()), /*#__PURE__*/React.createElement(Box, {
    padding: "21px 0 8px 0"
  }, /*#__PURE__*/React.createElement(Box, {
    typography: "bodyMediumBold",
    paddingBottom: "12px"
  }, T.translate('MODAL_CONTENT_TITLE')), userTrials.map(userTrial => /*#__PURE__*/React.createElement(TrialModalItem, {
    key: userTrial.offeringCategory,
    userTrial: userTrial
  }))), /*#__PURE__*/React.createElement(Box, {
    borderTop: "1px solid ".concat(Theme.colors.charcoal200),
    paddingTop: "24px"
  }, /*#__PURE__*/React.createElement(A, {
    style: footerHelpLinkStyle,
    href: HELP_LINK,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Box, {
    paddingRight: "15px",
    typography: "bodyMediumBold"
  }, T.translate('MODAL_FOOTER_HELP_LINK')), /*#__PURE__*/React.createElement(OpenIcon, null))));
};
TrialModal.displayName = 'TrialModal';
TrialModal.propTypes = {
  /** Handler for close modal event */
  onClose: PropTypes.func.isRequired,
  /**  Flag to display modal */
  show: PropTypes.bool.isRequired,
  /** User Trials data to display */
  userTrials: PropTypes.arrayOf(subscriptionPropType.isRequired).isRequired
};
export default TrialModal;
//# sourceMappingURL=component.js.map